import { useState } from 'react'

export const useForm = (initialForm = {}) => {

  const [formState, setFormState] = useState(initialForm)

  const onInputChange = ({ target }) => {
    const { name, value } = target


    if (target.name === 'autorizacion') {
      setFormState({
        ...formState,
        [name]: target.checked
      })
      return
    }

    setFormState({
      ...formState,
      [name]: value
    })
  }

  const setArchivos = (files) => {
    setFormState({
      ...formState,
      archivos: files
    })
  }

  const onResetForm = () => {
    setFormState(initialForm)
  }

  return {
    ...formState,
    formState,
    onInputChange,
    onResetForm,
    setArchivos
  }
}